<template>
  <div class="flyouts-uvp uvp-hover-info">UVP des Herstellers</div>
</template>
<style lang="postcss" scoped>
.uvp-hover-info {
  @apply whitespace-nowrap border bg-white rounded-none bottom-full text-sm font-normal left-full not-italic mb-2.5 py-2.5 px-4 pointer-events-none text-center -translate-x-1/2 absolute;
}
</style>
